import { PageTitle } from '@/components/page-title'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Login from '@/container/login'
import nextI18nextConfig from '../../next-i18next.config'

const LoginIndex = () => {
  const { t } = useTranslation('login')

  return (
    <>
      <PageTitle parts={[t('page_title')]} />
      <Login />
    </>
  )
}

export const getServerSideProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common', 'login'], nextI18nextConfig)),
  },
})

export default LoginIndex
